import type { IxcPortfolioV1TransactionKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const getPortfolioTransactionPath: EntityPathBuilder<IxcPortfolioV1TransactionKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      if (!context?.keys) {
        return undefined;
      }

      return getResolvedPath('/registration/account/$accountId/transaction', context.keys);
    case 'detail': {
      if (!context?.keys?.transactionId) {
        return undefined;
      }

      return getResolvedPath('/registration/account/$accountId/transaction/$transactionId', context.keys);
    }
  }
};

export function getPortfolioTransactionDetailPath(accountId: string | undefined, transactionId: string | undefined) {
  if (!accountId || !transactionId) {
    return undefined;
  }

  return getPortfolioTransactionPath({ kind: 'detail', keys: { accountId, transactionId } });
}
